import React from 'react';
import { Outlet } from 'react-router-dom';

const SettingsContent = () => {
  return <Outlet />;
};

export default SettingsContent;
